import styled from 'styled-components';

const FeaturetteStyles = styled.section`
  padding: ${props => (props.padding ? '1.59375rem' : '0')} 1rem;

  > .inner {
    margin: auto;
    display: flex;
    flex-direction: column;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    padding-bottom: 5rem;
    
    h2 {
      margin-top: 0;
      font-size: ${props => props.theme.type.h2Mobile};
      line-height: ${props => props.theme.lineHeights.h2Mobile};

      @media (min-width: ${props => props.theme.breakpoints.tablet}) {
        font-size: ${props => props.theme.type.h3};
        line-height: ${props => props.theme.lineHeights.h3};
      }
    }

    a {
      font-size: ${props => props.theme.type.button.large};
    }

    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      .column {
        &:last-child {
          order: ${props => (props.reverseOnMobile ? '-1' : '0')};
        }

        > div {
          margin-top: 1.5rem;
        }
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      flex-direction: row;
      justify-content: space-between;
      align-items: ${props => (props.center ? 'center' : 'flex-start')};
      max-width: ${props => props.theme.maxWidths.featurette};

      .column {
        width: calc(50% - 1.5rem);

        > div {
          max-width: 31rem;
          margin-top: 1rem;
        }

        &:first-child {
          > div {
            margin-left: auto;
          }

          picture {
            &::before {
              transform: translate(-1.8125rem, 1.8125rem);

              @media (prefers-reduced-motion: no-preference) {
                .isAnimated& {
                  transform: none;
                }
              }

              .active& {
                transform: translate(-1.8125rem, 1.8125rem);
              }
            }
          }
        }

        picture {
          &::before {
            transform: translate(1.8125rem, 1.8125rem);

            @media (prefers-reduced-motion: no-preference) {
              .isAnimated& {
                transform: none;
              }
            }

            .active& {
              transform: translate(1.8125rem, 1.8125rem);
            }
          }
        }
      }
    }

    .column {
      > div {
        @media (prefers-reduced-motion: no-preference) {
          .isAnimated& {
            opacity: 0;
            transform: translateY(10px);
          }

          .active& {
            animation: 0.4s ease-in-out slide-in-up forwards;
          }
        }

        &.video_wrapper {
          position: relative;
          max-width: initial;

          > svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -30%);
          }
        }
      }
    }

    picture {
      position: relative;
      display: block;
      width: 100%;
      height: 0;
      padding-top: 62%;
      background: ${props => props.theme.colors.grey6};
      margin: 0;

      @media (prefers-reduced-motion: no-preference) {
        .isAnimated& {
          opacity: 0;
          transform: scale(1.1);
          transition: all 0.4s ease-in-out;
        }
      }

      .active& {
        opacity: 1;
        transform: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        width: calc(100% - 2.5rem);

        &::before {
          position: absolute;
          display: ${props => props.dropShadow ? 'block' : 'none'};
          content: '';
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
          background: ${props => props.theme.colors.blue10};
          z-index: -1;

          @media (prefers-reduced-motion: no-preference) {
            .isAnimated& {
              transition: all 0.4s ease-in-out;
              transition-delay: 0.4s;
            }
          }
        }
      }
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: ${props => (props.padding ? '0 3rem 2rem' : '0 3rem')};
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: ${props => (props.padding ? '8.0625rem' : '0')} 3rem;
  }

  ${props => props.theme.animations.slideInUp};
`;

export default FeaturetteStyles;
